import IConfig from 'app/config/Config'

import { UserStore } from '../..'

interface RefreshResponse {
  success: boolean
  auth: {
    accessToken: string
    refreshToken: string
    accessTokenExpiry: number
    refreshTokenExpiry: number
  }
  user: {
    id: string
    email: string
    fullName: string
    tier?: string
    profileImage?: string
    onboardingCompleted?: boolean
  }
  error?: string
}

/**
 * Web implementation of access token refresh.
 * Uses the /api/auth/refresh endpoint which handles SSA (client_secret) server-side.
 * This is necessary because web uses SSA OAuth flow (no PKCE), so the client
 * cannot refresh tokens directly with Memberful.
 */
const refreshAccessToken = async (
  _store: UserStore,
  _config: IConfig
): Promise<{ auth: any; user: any } | null> => {
  try {
    const response = await fetch('/api/auth/refresh', {
      method: 'POST',
      credentials: 'include', // Send Iron Session cookie
      headers: {
        'Content-Type': 'application/json',
      },
    })

    if (!response.ok) {
      // 401: refresh token invalid/expired
      // 500: server error
      // Either way, user should be logged out
      console.error('[refreshAccessToken.web] Refresh failed:', response.status)
      return null
    }

    const data: RefreshResponse = await response.json()

    if (!data.success) {
      console.error('[refreshAccessToken.web] Refresh unsuccessful:', data.error)
      return null
    }

    return {
      auth: data.auth,
      user: data.user,
    }
  } catch (error) {
    console.error('[refreshAccessToken.web] Network error:', error)
    return null
  }
}

export default refreshAccessToken
